import React, { useContext, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import StandardDropdown from '../../../Dropdown/Preset/StandardDropdown';
import s from './ThreadOrderSelect.scss';
var ThreadOrderSelect = function (_a) {
    var streamId = _a.streamId, order = _a.order, onOrderChanged = _a.onOrderChanged;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var profile_mobile_heading = useFlag('profile_mobile_heading');
    var handleOrderChanged = useCallback(function (value) {
        onOrderChanged && onOrderChanged(streamId, value);
    }, [onOrderChanged, streamId]);
    var items = useMemo(function () { return [
        {
            label: t('commentthread.control.newest'),
            value: 'newest',
        },
        {
            label: t('commentthread.control.oldest'),
            value: 'oldest',
        },
    ]; }, [t]);
    return (React.createElement("div", { className: cn(s['order-select'], profile_mobile_heading && s['profile_mobile_heading']), "data-hook": BiDataHook.COMMENTS_THREAD_SORTING },
        React.createElement(StandardDropdown, { role: "menu", placement: isMobile ? 'bottom-end' : 'bottom-start', toggleClassName: s['order-select-toggle'], arrowClassName: s['order-select-arrow'], selectedValue: order, items: items, onSelect: handleOrderChanged })));
};
ThreadOrderSelect.displayName = 'ThreadOrderSelect';
export default ThreadOrderSelect;
//# sourceMappingURL=ThreadOrderSelect.js.map